export default {
  DONATION_ACTION_FETCHED: 'DONATION_ACTION_FETCHED',
  DONATION_ACTION_LOAD: 'DONATION_ACTION_LOAD',
  DONATION_ACTION_TEMPLATES_FETCHED: 'DONATION_ACTION_TEMPLATES_FETCHED',
  DONATION_ACTION_TEMPLATES_LOAD: 'DONATION_ACTION_TEMPLATES_LOAD',
  DONATION_ACTION_DETAIL: 'DONATION_ACTION_DETAIL',
  DONATION_ACTION_BUTTON_LOAD: 'DONATION_ACTION_BUTTON_LOAD',
};
